import React from 'react';

import { Redirect } from 'react-router-dom';
import MerchantSignupStart from '../../components/Merchant/MerchantSignup/MerchantSignupStart';
import MerchantUserInfoPage from '../../components/Merchant/MerchantUserInfoPage';
import { config } from '../../configs/config';
import { UserRoles } from '../../constants/role';
import { ROUTES } from '../../constants/route';
import { useAuth } from '../../hooks/useAuth';

const MerchantSignupPage: React.FC = () => {
  const { isAuthenticated } = useAuth();
  
  const userRole =
    localStorage.getItem(config.userRoleKey) || sessionStorage.getItem(config.userRoleKey);

  if (userRole === UserRoles.PDA && isAuthenticated) {
    return (<MerchantUserInfoPage />);  
  } else if (userRole === UserRoles.MERCHANT && isAuthenticated) {
    return (<Redirect to={ROUTES.MERCHANT_DATA_PASS} />);
  } else {
    return (<MerchantSignupStart />);
  }
};

export default MerchantSignupPage;
